import React, { Component } from 'react'
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl'
import './welcome.scss'
import Icon from "../common/icon/icon.component.jsx";
import SideBar from "../common/layout/sidebar.component.jsx"
import GlobalHelper from '../common/GlobalHelper.jsx';
import { AppContext } from '@lightspeed-invoicing/core-client/frontend'
import { Link } from 'react-router-dom'
import ShopifyAppContext from '../shopify/shopifyappcontext.js'
import StartUpGuideContainer from "./sections/StartUpGuideContainer";

class Congratulations extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            contact: null,
            contactImport: null,
            productImport: null,
            quote: null,
            quoteId: '',
            proposal: null,
            modal: null,
            redirect: null,
            templates: [],
            welcomeMessage: '',
            email: AppContext.getUserLoggedIn().attributes.email,
        }
    }

    componentDidMount() {
        SideBar.activateMenu('')
        if (GlobalHelper.hasLightspeedIntegration()) {
            let isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime)
            let isFirefox = typeof InstallTrigger !== 'undefined'
            let navigatorName = ''
            let installButton = ''
            let url = ''
            if (isChrome) {
                navigatorName = "Chrome"
                url = "https://chrome.google.com/webstore/detail/quotemachine/bojgededaoabbjpgffkcgmegacndgjdp?hl=en"
                installButton = <a href={url} target="_blank">
                    <img src='/images/chrome_web_store_border.png' height='65px' />
                </a>
            } else if (isFirefox) {
                navigatorName = "Firefox"
                url = "https://addons.mozilla.org/en-US/firefox/addon/quotemachine/"
                installButton = <a className="btn btn-light border" href={url} target="_blank">
                    <img src='/images/firefox_logo.svg' height='65px' className="mr-2" />
                    <h4 className="d-inline">
                        <FormattedMessage
                            id="congrats.app_extension_firefox_open_add_on"
                            defaultMessage="Install firefox add-on"
                        />
                    </h4>
                </a>
            }

            this.setState({
                welcomeMessage: <div>
                    <div className={'strong w-100 mb-3 mt-5'}>
                        <FormattedMessage
                            id="congrats.initial_import_started"
                            defaultMessage="We started an initial import of all your inventory and contacts. The process should finish in a few hours."
                        />
                    </div>
                    {navigatorName !== "" && <div className={'ui-module mb-5'}>
                        <div className={'d-flex align-items-center w-100'}>
                            <div className={'text-left'}>
                                <FormattedMessage
                                    id="congrats.recommend_app_extension"
                                    defaultMessage="To improve your experience, we strongly recommend you to install our official {navigatorName} extension by clicking on the button below."
                                    values={{
                                        navigatorName: <strong>{navigatorName}</strong>
                                    }}
                                />
                            </div>
                            <div >
                                {installButton}
                            </div>
                        </div>
                        <div className={'text-center w-100'}>
                            <a href={url} className={'btn btn-outline-primary'} target={'_blank'}>
                                <Icon value="puzzle-piece" className={"mr-1"} />
                                <FormattedMessage
                                    id="congrats.install_app_extension"
                                    defaultMessage="Install extension"
                                />
                            </a>

                        </div>
                    </div>}

                </div>
            })
        } else if (GlobalHelper.hasShopifyExpertAppIntegration()) {

            // Previous message to enable the extension themself
            // this.setState({
            //     welcomeMessage: <div className={'strong w-100 mb-3 mt-5'}>
            //         <FormattedMessage
            //             id="congrats.recommend_shopify_messenger"
            //             defaultMessage="Next step is to enable QuoteMachine messenger on your website from your theme settings"
            //         />
            //         <div className={'strong w-100 mb-3 border-bottom d-flex align-items-center'}>
            //             <div className={'strong w-50 mb-3'}>
            //                 <img src='/images/qm_messenger.png' height='400px' className="mr-2" />
            //             </div>
            //             <div className={'strong w-50 mb-3 text-left'}>
            //                 <a className={'btn btn-primary mb-4'} target={'_blank'}
            //                    href={'https://'+ GlobalHelper.getShopifyIntegrationOrigin() +'/admin/themes/current/editor?context=apps&appEmbed=8665cede-41ae-418e-b746-458bd3120efb%2Ffloating-button'}>
            //                     <Icon value={'comment'} className={'mr-2'}/>
            //                     <FormattedMessage
            //                         id="congrats.enable_qm_messenger"
            //                         defaultMessage="Enable QuoteMachine Messenger"
            //                     />
            //                 </a>
            //                 <a className={'btn btn-outline-primary'} target={'_blank'}
            //                    href={'http://support.quotemachine.com/en/articles/5622778-adding-quotemachine-messenger-on-your-shopify-website'}>
            //                     <Icon value={'file-alt'} className={'mr-2'}/>
            //                     <FormattedMessage
            //                         id="congrats.qm_messenger_documentation"
            //                         defaultMessage="Documentation"
            //                     />
            //                 </a>
            //             </div>
            //         </div>
            //     </div>
            // })


            this.setState({
                welcomeMessage: <div className={'strong w-100 mb-3 mt-5'}>
                    <FormattedMessage
                        id="congrats.shopify_book_a_demo"
                        defaultMessage="Next step is to book a free 1:1 on boarding session with our specialist to help you setup your store"
                    />
                    <p className={"text-center mb-5"}>
                        <a href={'https://meetings.hubspot.com/anna-brundage/round-robin-demo'} className={'btn btn-lg btn-outline-primary'}>
                            <Icon value="chart-line" className={"mr-1"} />
                            <FormattedMessage
                                id="congrats.shopify_book_a_demo_btn"
                                defaultMessage="Book your free on boarding session"
                            />
                        </a>
                    </p>
                </div>
            })
        } else {
            this.setState({
                welcomeMessage: <div className={'strong w-100 mb-3 mt-5'}><FormattedMessage
                    id="congrats.configuration_success"
                    defaultMessage="We successfully configured your account. You can start selling from QuoteMachine right now!"
                /></div>
            })
        }
    }


    render() {
        return (
            <div className="row ui-has-modules py-0 justify-content-center mt-2">
                {this.state.modal}
                {this.state.redirect}
                <div className="col-lg-10 col-md-10 col-12">
                    <div className="row">
                        <div className="col-12 py-0">
                            <p className="text-center">
                                <img src='/images/astronaut.svg' width='200px' />
                            </p>
                            <h1 className="text-center custom-lead text-custom-primary mb-2">
                                <FormattedMessage
                                    id="congrats.title"
                                    defaultMessage="Congratulations!"
                                />
                            </h1>
                            <div className="text-center mb-4 w-75 mx-auto">
                                {this.state.welcomeMessage}
                            </div>

                            {GlobalHelper.integrationSupportsStartUpGuides(AppContext.getAccount().attributes.integrationKey) &&
                                <StartUpGuideContainer />
                            }

                            {GlobalHelper.hasLightspeedIntegration() &&
                                <div className="text-center mb-4 w-75 mx-auto">
                                    <div>
                                        <div className={'strong w-100 mb-3 mt-5'}>
                                            <FormattedMessage
                                                id="congrats.email_with_credentials_sent"
                                                defaultMessage="We also sent your temporary credentials to {email} We recommend you to change your password by clicking on the button below."
                                                values={{
                                                    email: <h5 className="text-secondary mt-2">{this.state.email}</h5>,
                                                }}
                                            />
                                        </div>
                                        <div className={'ui-module mb-5'}>
                                            <div className={'d-flex align-items-center justify-content-center w-100'}>
                                                <div>
                                                    <Link
                                                        className={'btn btn-outline-primary'}
                                                        to={{
                                                            pathname: "/users/edit/" + AppContext.getUserLoggedIn().id,
                                                            state: {
                                                                cancelRedirectPath: "/congrats",
                                                                saveRedirectPath: "/congrats",
                                                            }
                                                        }}
                                                    >
                                                        <FormattedMessage
                                                            id="congrats.change_password"
                                                            defaultMessage="Change your password"
                                                        />
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            }

                            {
                                GlobalHelper.getShopifyIntegrationOrigin() ?
                                    <p className={"text-center mb-5"}>
                                        <btn onClick={() => {
                                            ShopifyAppContext.redirectToDashboard()
                                        }} className={'btn btn-lg btn-outline-primary'}>
                                            <Icon value="chart-line" className={"mr-1"} />
                                            <FormattedMessage
                                                id="congrats.see_dashboard_btn"
                                                defaultMessage="Open your dashboard"
                                            />
                                        </btn>
                                    </p>
                                    :
                                    <p className={"text-center mb-5"}>
                                        <a href={'/'} className={'btn btn-lg btn-outline-primary'}>
                                            <Icon value="chart-line" className={"mr-1"} />
                                            <FormattedMessage
                                                id="congrats.see_dashboard_btn"
                                                defaultMessage="Open your dashboard"
                                            />
                                        </a>
                                    </p>
                            }
                            <p>
                                <hr />
                            </p>
                            <div className="d-flex w-100 mb-3 justify-content-center">
                                <div className={"p-3"}>
                                    <img src='/images/video_call.svg' width='150px' />
                                </div>
                                <div className="d-flex align-items-center p-2">
                                    <div>
                                        <h5>
                                            <FormattedMessage
                                                id="congrats.demo_title"
                                                defaultMessage="You'd rather have us demo? No problem."
                                            />
                                        </h5>
                                        <p className={"mb-0"}>
                                            <FormattedMessage
                                                id="congrats.demo_message_1"
                                                defaultMessage="Book a demo and we'll show you how QuoteMachine can fulfill your needs."
                                            />
                                        </p>
                                    </div>
                                    <div className={"pl-4 w-25"}>
                                        <p className={"mb-0 mt-2"}>
                                            <a target={'_blank'} href={GlobalHelper.getDemoLink()} className={'btn btn-outline-primary'}>
                                                <FormattedMessage
                                                    id="congrats.demo_btn"
                                                    defaultMessage="Book a demo"
                                                />
                                                <Icon value={"chevron-right"} className={"ml-1"} />
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default injectIntl(Congratulations)





// WEBPACK FOOTER //
// ./src/onboarding/congratulations.component.jsx